/* istanbul ignore file */
// Polyfill for 'self' in Node.js environment (server-side rendering)
// This fixes the "ReferenceError: self is not defined" error from @procore/cdn-translations
if (typeof self === 'undefined') {
  // @ts-expect-error --- global.self is not defined
  global.self = global;
  global.self.localStorage = globalThis.localStorage;
  global.self.sessionStorage = globalThis.sessionStorage;
  global.self.navigator = globalThis.navigator;
  global.self.window = globalThis.window;
}
